import EntityActionRegistry from './EntityActionRegistry';
import { WorkflowDesigner } from '../components/workflows/WorkflowDesigner';
import { WorkflowStepEditDialog, GenericEntityUpsertDialog } from '../components/dialogs';

/**
 * Initialize all entity actions
 * This should be called once during app startup
 */
export const initializeEntityActions = (): void => {
    const actionRegistry = EntityActionRegistry.getInstance();

    // Register Set entity actions (GenericEntityUpsertDialog with SetFormLayout)
    actionRegistry.registerActions('Set', [
        {
            id: 'create',
            label: 'Create Set',
            icon: 'add',
            component: GenericEntityUpsertDialog,
            requiresAuth: true
        }
    ]);

    // Register PolicyRule entity actions
    actionRegistry.registerActions('PolicyRule', [
        {
            id: 'create',
            label: 'Create Policy Rule',
            icon: 'add',
            component: GenericEntityUpsertDialog,
            requiresAuth: true
        }
    ]);

    // Register Workflow entity actions
    actionRegistry.registerActions('workflow', [
        {
            id: 'create',
            label: 'Create Workflow',
            icon: 'add',
            component: WorkflowDesigner,
            requiresAuth: true
        }
    ]);

    // Register WorkflowActivity entity actions
    actionRegistry.registerActions('WorkflowActivity', [
        {
            id: 'create',
            label: 'Create Workflow Activity',
            icon: 'add',
            component: WorkflowStepEditDialog,
            requiresAuth: true
        }
    ]);

    // Register EmailTemplate entity actions
    actionRegistry.registerActions('EmailTemplate', [
        {
            id: 'create',
            label: 'Create Email Template',
            icon: 'add',
            component: GenericEntityUpsertDialog,
            requiresAuth: true
        }
    ]);

    // Register SetTransition entity actions
    actionRegistry.registerActions('SetTransition', [
        {
            id: 'create',
            label: 'Create Set Transition',
            icon: 'add',
            component: GenericEntityUpsertDialog,
            requiresAuth: true
        }
    ]);

    // Register RequestApprovalType entity actions
    actionRegistry.registerActions('RequestApprovalType', [
        {
            id: 'create',
            label: 'Create Request Approval Type',
            icon: 'add',
            component: GenericEntityUpsertDialog,
            requiresAuth: true
        }
    ]);

    // Register other entity actions here as needed
    // Example:
    // actionRegistry.registerActions('User', [
    //     {
    //         id: 'create',
    //         label: 'Create User',
    //         icon: 'add',
    //         component: UserCreationDialog,
    //         requiresAuth: true
    //     },
    //     {
    //         id: 'bulk-import',
    //         label: 'Bulk Import Users',
    //         icon: 'upload',
    //         component: UserBulkImportDialog,
    //         requiresAuth: true,
    //         permissions: ['user:bulk-import']
    //     }
    // ]);
};

